const serviceEnglish = () => ({
  servicesTitle: 'My services',
  title: {
    part1: '5+ YEARS OF',
    part2: 'EXPERIENCE IN WEBFLOW',
    part3: 'DEVELOPMENT',
  },
  services: {
    serv1: 'DEVELOPMENT',
    serv2: 'DESIGN',
    serv3: 'TECH SOLUTIONS',
    serv4: 'USER EXPERIENCE',
  },
  ilustration: {
    backend: 'Backend development',
    frontend: 'Frontend development',
    mobile: 'Mobile development',
  },
});

export default serviceEnglish;
